window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap');
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js';
var jQueryBridget = require('jquery-bridget');
var Masonry = require('masonry-layout');
// make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, $);

$.fn.tagNameLowerCase = function () {
  return this.prop('tagName').toLowerCase()
}
//картинки в натуральную величину загружаются по мере появления на экране (Intersection Observer используется)
document.addEventListener("DOMContentLoaded", function () {
    new IOlazy({
        image: '.lazyload2'
    });
});

$(function () {

    Fancybox.bind('[data-fancybox="gallery"]', {
        Thumbs: {
            type: "classic",
        },
    });

  $('.lazyload').each(function () {
    let el = $(this)
    if (el.data('src')) {
      el.attr('src', el.data('src'))
      if (el.tagNameLowerCase() == 'source' && el.parent().tagNameLowerCase() == 'video') {
        el.parent()[0].load()
        el.parent()[0].play()
      }
    }
  })

    const videoModal = document.getElementById('modal-video')
    if (videoModal) {// сейчас модалка с громадным видео есть на главной странице
        videoModal.addEventListener('show.bs.modal', event => {
            let el = $('#modal-video source')
            if (el.data('src')) {
                el.attr('src', el.data('src'))
                if (el.tagNameLowerCase() == 'source' && el.parent().tagNameLowerCase() == 'video') {
                    el.parent()[0].load()
                    el.parent()[0].play()
                }
            }
        })
        //видео нужно остановить при закрытии модалки (иначе видео продолжает играть в фоне)
        videoModal.addEventListener('hide.bs.modal', event => {
            $('#modal-video video').trigger('pause')
        })
    }

    $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open');
        $('body').toggleClass('mobile-navbar-show');
    });

    $('body > .pattern').on('click', function () {
        $('.navbar-icon-close').click();
    });

    // Back to Top
    $(document).scroll(function () {
        if ($(this).scrollTop() > 1) {
            $('.scroll-up').removeClass('hidden').addClass('show');
        } else {
            $('.scroll-up').removeClass('show').addClass('hidden');
        }
    });

    $('.scroll-up').click(function () {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('[name="_token"]').attr('value')
        }
    });
    //форма отправки 1 статьи блога на указанную почту
    $('.send-article-form').submit(function (e) {
        e.preventDefault();
        ym && ym(54018781, 'reachGoal', 'BRL');
        var form = $(this),
            validate = validateForm(form);
        if (validate) {
            var arrayFormData = getAssocArray(form);
            form.find('button').attr('disabled', 'disabled');
            arrayFormData['page'] = window.location.pathname === '/' ? '/index/' : window.location.pathname;
            $.ajax({
                type: "POST",
                url: '/sendarticle',
                context: form,
                data: arrayFormData,
                success: function (data) {
                    form.find('button').removeAttr('disabled');
                    $('.article-blog .form-content').fadeOut(150);
                    $('.article-blog .success-result').fadeIn(150);
                },
                error: function (err) {
                    form.find('button').removeAttr('disabled');
                    console.error(err);
                    if (err.status === 422 && err.responseJSON && err.responseJSON.message) {
                        alert(err.responseJSON.message);
                    } else {
                        alert('Error: ' + err);//@todo сделать красивое окно
                    }
                }
            });
        }
    });
    //форма в блоге внизу статьи - подписка на новые статьи
    $('.subscribe-article-form').submit(function (e) {
        ym && ym(54018781, 'reachGoal', 'BRL');
        e.preventDefault();
        var $form = $(this);
        $form.find('button').attr('disabled', 'disabled');
        $.ajax({
            type: "POST",
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
                $form.find('button').removeAttr('disabled');
                $form[0].reset();
                $('#successSubscribeModal').modal('show');
                setTimeout(function () {
                    $('#successSubscribeModal').modal('hide');
                }, 5000);
            },
            error: function (e) {
                $form.find('button').removeAttr('disabled');
                console.error(e);
                var message = 'responseJSON' in e ? e.responseJSON.message : 'Произошла ошибка подписки :(';
                alert(message);
            }
        });
    });

    function validateForm(form) {
        var validate = true;
        form.find('input, textarea, select').each(function (key, item) {
            var obj = $(item);
            if (obj.attr('required') === 'required' || obj.attr('required')) {
                if (obj.val() !== "" || obj.prop('checked')) {
                    validate = !validate ? validate : true;
                    obj.removeClass('is-invalid');
                } else {
                    validate = false;
                    obj.addClass('is-invalid');
                }
                if (obj.attr('type') == 'email' && !validateEmail(obj.val())) {
                    validate = false;
                    obj.addClass('is-invalid');
                }
                if ( (obj.attr('name') === 'phone' || obj.attr('name') === 'tel') && !validatePhone(obj.val())) {
                    validate = false;
                    obj.addClass('is-invalid');
                }
            }
        });
        return validate;
    }

    $('.no-reading-button').click(function (e) {
        e.preventDefault();
        var button = $(this);
        if (!button.hasClass('active')) {
            $('.article-blog .got-time').show();
            $('.article-blog .no-time').hide();
            $('.article-blog .form-body').fadeIn(200);
            button.addClass('active');
        } else {
            $('.article-blog .got-time').hide();
            $('.article-blog .no-time').show();
            $('.article-blog .form-body').fadeOut(200);
            button.removeClass('active');
        }
    });

    $('.showMore').click(function (e) {
        e.preventDefault();

        let showMoreBtnNode = $(this),
            currentPage = eval(this.dataset.currentPage);

        if (currentPage != undefined) {
            $('.articles-news .loading-container').fadeIn(150);
            $.ajax({
                type: "GET",
                url: window.location.href + '?page=' + (currentPage + 1),
                dataType: 'html',
                success: function (data) {
                    $('.articles-news .loading-container').hide();
                    var articles = $('<div/>').html(data).find('.articles-news .row .col');
                    $('.articles-news .row').append(articles);

                    new IOlazy({
                        image: '.lazyload2'
                    });
                    if ((currentPage + 1) == showMoreBtnNode.data('page-count')) {
                        showMoreBtnNode.hide();
                    }

                    showMoreBtnNode.attr('data-current-page', (currentPage + 1));
                },
                error: function () {
                    console.log('error');
                }
            });
        }
    });

    $('.select__trigger').click(function () {
        $(this).parents('.select').find('.select__dropdown').toggle();
    })

    $('[name="phone"]').on('focus', function () {
        if ($(this).val() === '')
            $(this).val('+');
    });

    $('[name="phone"]').on('focusout', function () {
        if ($(this).val() === '+')
            $(this).val('');
    });

    $('[name="phone"]').on("keydown", function (e) {
        if (e.keyCode == 8 && $('[name="phone"]').is(':focus') && $('[name="phone"]').val().length < 2) {
            e.preventDefault();
        }
    });

    $('[name="phone"]').on('input', (e) => {
        e.target.value = e.target.value.replace(/[^+\d]/g, '')
    })

    $(document).mouseup(function (e) { // событие клика по веб-документу
        var div = $(".select__dropdown"); // тут указываем ID элемента
        if (!div.is(e.target) // если клик был не по нашему блоку
            && div.has(e.target).length === 0) { // и не по его дочерним элементам
            div.hide(); // скрываем его
        }
    });

    var $grid;

    if ($(window).width() >= 768)
        $grid = $('.grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: 340,
            gutter: 20,
            fitWidth: true
        });

    $('.copy-link').click(function (e) {
        e.preventDefault();
        copytext(window.location.href);
        $('.link-text').hide();
        $('.copy-success').fadeIn(150);
        $(this).css('pointer-events', 'none');
        $('.article-blog .article-body .social .share-icon').addClass('done')
        setTimeout(function () {
            $('.copy-success').hide()
            $('.link-text').fadeIn(150);
            $('.copy-link').css('pointer-events', 'all');
            $('.article-blog .article-body .social .share-icon').removeClass('done');
        }, 3000)
    });

    // $('.multibutton').hover(
    //     function () {
    //         $('.multibutton .minor_icons').addClass('active');
    //     },
    //     function () {
    //         $('.multibutton .minor_icons').removeClass('active');
    //     })
    $('.article-text img[src*="/img/blog/"]').each(function(ind, el) {
        var $el = $(el);
        var src= $el.attr('src');
        var filename = src.split("/").pop();
        var dir = src.substring(0, src.lastIndexOf('/')) + "/";
        //console.log(filename, dir);
        var src2x = `${dir}2x/${filename}`;
        var src3x = `${dir}3x/${filename}`;
        var srcSet = `${src} 1x, ${src2x} 2x, ${src3x} 3x`;
        $el.attr('srcset', srcSet);
    })
});

$(document).ready(function () {
    if (window.screen.width > 991)
        $(window).scroll(function () {
            var position = $(this).scrollTop();

            $('.article-text h2').each(function () {
                var target = $(this).offset().top;

                var id = $(this).attr('id');
                if (position >= target - 80) {
                    $('.article-navigation li a.active').removeClass('active');
                    $('.article-navigation li a[href="#' + id + '"]').addClass('active');
                }
            });
        });
});

// $(window).on("load", function () {
//     $('.events_slider').slick({
//         prevArrow: '<button type="button" class="slick-prev"></button>',
//         nextArrow: '<button type="button" class="slick-next"></button>'
//     });
// });

function getAssocArray(form) {
    var resultObj = {};

    $.each($(form).serializeArray(), function (key, row) {
        resultObj[row.name] = row.value;
    });

    return resultObj;
}

function copytext(el) {
    var $tmp = $("<textarea>");
    $("body").append($tmp);
    $tmp.val(el).select();
    document.execCommand("copy");
    $tmp.remove();
}

function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
    const rePhone = phone.replace(/[^+\d]/g, '');
    return rePhone.length > 5;
}

// var iconCounter = 2;
// var interval = setInterval(function () {
//     iconChanger()
// }, 2000);
//
// function iconChanger() {
//     if (iconCounter > $('.multibutton .main_icons .icon_item').length) iconCounter = 1;
//     $('.multibutton .active.icon_item').toggleClass('active');
//     $('.multibutton .main_icons .icon_item:nth-child(' + iconCounter + ')').toggleClass('active');
//     iconCounter++;
// }

window.onloadRecaptchaCallback = function () {

};
